import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import { LocalisationButton, Tooltip } from 'components/atoms'
import * as Styled from './FeatureList.styles'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const FeatureList = ({ itemList, listClass = '' }) => {
  const textContext = useContext(TextContext)

  const getValueByType = (item) => {
    const dataIsString = typeof item === 'string' || item instanceof String

    return dataIsString ? (
      <span>{item}</span>
    ) : (
      <>
        <span>
          {item.title}
          {item.tooltip && (
            <Tooltip
              infoIconId={ item.title }
              dialogTitle={ item.title }
              tooltipId={ item.title }
              className={ 'feature-list-tooltip' }
              closeOnClickOutside={ item.showLocalisation }>
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(item.tooltip),
                }}
              />
              {item.showLocalisation && (
                <span className={ 'tooltip-location-btn' }>
                  <LocalisationButton />
                </span>
              )}
            </Tooltip>
          )}
        </span>
      </>
    )
  }

  return (
    <Styled.FeatureListComponent data-cy={ 'feature-List' }>
      {!!itemList &&
        itemList?.map((data, index) => (
          <div key={ index }>
            {data.headline && (
              <p>
                <b>{data.headline}</b>
              </p>
            )}
            {data.items && (
              <ul className={ listClass }>
                {data.items.map((item, index) => (
                  <li key={ index }>{getValueByType(item)}</li>
                ))}
              </ul>
            )}
            {!data.items && (
              <p className={ 'no-feature-hint' }>
                {textContext['features.none']}
              </p>
            )}
          </div>
        ))}
    </Styled.FeatureListComponent>
  )
}

FeatureList.propTypes = {
  itemList: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      items: PropTypes.array,
    })
  ),
  listClass: PropTypes.string,
}

export default FeatureList
